/* global Backbone, _ */

'use strict';

var Backbone              = require('backbone');
var _                     = require('lodash');

module.exports = Backbone.Model.extend({

    apiUrl: 'https://tailor-dev.telescope.tv/1.0/resumable_upload/video',
    // http://tailor.telescope.tv/1.0/resumable_upload?
        // job_id=job_id
        // &upload_reference=upload_reference
        // &upload_phase=upload_phase
        // &start_offset=start_offset
        // &file_size=filesize
        // &filename=filename
    defaults: {
      'upload': null,
      'jobId': 0,
      // include a failureCount and max attempts to retry the chunk upload if
      // the push was not successful, due to connection or something else
      // 60 max attempts would be 3 minutes max retries on any one chunk
      failureCount: 0,
      maxAttempts: 60,
      retryTimeout: 5
    },

    //4c6f53ab-c4a9-462c-8bf3-8b32cad21d21
    /**
     * Initialize
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     */
    initialize: function(attributes, options) {
      options = options || {};
      
      this.auth_token = options.auth_token;
      this.videoUpload = options.videoUpload;

      if(options.apiUrl && options.apiUrl!=='') {
        this.apiUrl = options.apiUrl;
      }
    },

    /**
     * Returns URL root
     * @return {String} [description]
     */
    urlRoot: function() {
      // If we are deciding to allow numerous file uploads, we will need to update upload_reference
      // with the index of the file we are currently uploading -- this is an index that starts from 1
      // var url = this.apiUrl + '?job_id=' + this.get('jobId') + '&upload_reference=1&Authorization=' + this.auth_token;
      var url = this.apiUrl; // '?Authorization=' + this.auth_token;

      return url;
    },
    /**
     * Save
     * @param  {Object} attributes [description]
     * @param  {Object} opts       [description]
     * @return {[type]}            [description]
     */
    save: function(attributes, opts) {
      if(typeof this.auth_token === 'undefined' || this.auth_token === null) {
        console.warn('Tailor API requires an authentication token.');
        return;
      }

      this.set({'upload_phase': 'start'})
      
      var options;

      //IE9!!!
      if (!Backbone.$.support.cors && window.XDomainRequest) {
        this.trigger('unsupported_browser', this);
        console.warn('Browser does not support cross-domain File upload.');
        return;
      }

      this.opts = opts;
      
      // QSPs to be passed for the initial call to start the job
      // We send to Tailor the size of the file, the filename and the job_id
      // Upload reference starts at 1 and would increment with each additional file, when we support more than 1 file upload
      var qspData = {
        upload_phase: 'start',
        file_size: this.get('upload').size,
        filename: this.get('upload').name,
        job_id: this.get('jobId'),
        upload_reference: 1
      };
      
      var data = new FormData();
      // create an empty file for starting the job
      data.append('files', '');

      var url = this.urlRoot() + this.toQSP(qspData);

      options = {
        type: 'POST',
        contentType: false,
        dataType: 'json',
        data: data,
        url: url
      };


      options = _.extend(options, opts);

      return Backbone.Model.prototype.save.call(this, attributes, options).then(
        function(response) {
          this.chunkUpData(response);
        }.bind(this),
        function(err) {
          this.trigger('upload-error', this, err, options);
        }.bind(this)
      );
    },
    /**
     * http://docs.telescopetailor20.apiary.io/#reference/tailor-api-endpoints/resumable-uploading-of-files-to-a-job/starting-a-job
     */
    chunkUpData: function(response) {
      this.chunks = [];
      // taken from ResumableJS to determine the chunk sizes
      // for slicing up the file to be sent to tailor

      // if the start is at the end of the chunk, this may not work properly
      // we may need Tailor to respond with the maxChunk size

      // Example response: 
      // Chunk size = 10,485,760
      // 
      // {
      //   "job_id": "0d1429039cfa0d273577ee28ade7bfa3",
      //   "upload_reference": "1",
      //   "start_offset": "20971520",
      //   "end_offset": "30317296"
      // }
      // Total offset = 9,345,776
      // 
      // {
      //   "job_id": "0d1429039cfa0d273577ee28ade7bfa3",
      //   "upload_reference": "1",
      //   "start_offset": "30317296",
      //   "end_offset": "30317296"
      // }
      // Total offset = 0;
      
      // if (start == uploadSize) => { continue to completion phase }
      // 

      var uploadSize = this.get('upload').size,
          start = parseInt(response.start_offset),
          responseEnd = parseInt(response.end_offset),
          chunkSize = responseEnd - start;

      var file = this.get('upload'),
          slice = (file.slice ? 'slice' : (file.mozSlice ? 'mozSlice' : (file.webkitSlice ? 'webkitSlice' : 'slice')));

      var end = Math.min(uploadSize, chunkSize);

      var maxOffset = Math.max(Math.ceil(uploadSize/chunkSize), 1);

      for (var offset=0; offset < maxOffset; offset++) {
          var startByte = (offset == 0) ? 0 : end;
          var endByte = end = Math.min(uploadSize, ( startByte + chunkSize ));

          // add in the byte at the end of slicing for the byte to NOT be included
          var blob = file[slice](startByte, endByte + 1);
          this.chunks.push(blob);
      }

      // lets make this more dynamic b/c Tailor may sometimes respond with a different start index
      // Per Tailor: an upload that has previous gotten to a specific point and the filesize/filename are the same, 
      // the server will return json requesting the bytes it needs next to continue this upload
      // 
      this.chunkIndex = Math.ceil(start / maxOffset); // 0;
      this.set({'chunk_count': this.chunks.length})
      this.afterSetUp(response);
    },
    /**
     * [afterSetUp description]
     * @param  {[type]} response [JSON object responding from Tailor endpoint with the jobId and the expected chunks for Tailor]
     * Continue on the calling of the Tailor model here, until we have completed and resolve the Tailor job.
     */
    afterSetUp: function(response) {
      console.warn('afterSetUp called: ', response);

      // set the response from Tailor to this.response
      // on unsuccessful calls, we will reference this response to rebuild the chunked job
      if(!this.response) {
        this.response = response;
      }

      response = this.response;

      this.set({
        'upload_phase': 'transfer',
        'chunk_index': this.chunkIndex
      });

      var attributes = {};
      
      // After the job is started, we begin to send the chunked data to Tailor
      // Tailor will respond with the start and end offsets, which will be the chunks we send
      var qspData = {
        upload_phase: 'transfer',
        job_id: this.get('jobId'),
        upload_reference: 1,
        start_offset: response.start_offset
      };

      // when the call is being made I'm receiving a 500 status code from Tailor
      // and 10526 as the code of reference, no indication of what it is on API docs
      // attempted to make a new file and pass that as the formData for Tailor but still no luck
      // when passing it as the Blob we still receive the same errors
      var data = new FormData();
      data.append('files', this.chunks[this.chunkIndex]);
      // data.append('file', newFile);
      
      var url = this.urlRoot() + this.toQSP(qspData);

      var options = _.extend({
        type: 'POST',
        contentType: false,
        dataType: 'json',
        data: data,
        url: url
      }, this.opts);

      return Backbone.Model.prototype.save.call(this, attributes, options).then(_.bind(this.determineCompletion, this)).fail(this.retryUploadPhase.bind(this, 'transfer'));
    },
    /**
     * [determineCompletion description]
     * @param  {[type]} response [description]
     * @return {[type]}          [description]
     */
    determineCompletion: function(response) {
      // reset the failureCount after a successful chunk upload and this.response
      this.set('failureCount', 0);
      this.response = null;

      console.warn('determineCompleteion response: ', response);
      // can we force the afterSetUp to be called only once
      if(!this.start_offset || response.start_offset !== this.start_offset) {
        
        this.start_offset = response.start_offset;
        // if the upload size is equal to the start offset, we have reached the end of the chunk uploading, 
        // submit the complete upload phase to Tailor
        if(parseInt(response.start_offset) == parseInt(response.end_offset)) {
          this.completeTailorUpload(response);
          return;
        }
          
        // we may need to make this portion for chunkIndex a little more dynamic as well
        // IF Tailor will allow us to send multiple requests/chunks of the file TBD at a later time
        this.chunkIndex++;

        this.afterSetUp(response);

        return;
      }

      this.start_offset = response.start_offset;

    },
    /**
     * 
     */
    completeTailorUpload: function(response) {
      this.set({'upload_phase': 'finish'});
      this.chunks = [];

      // make the finish call to Tailor
      // complete the job and send off the events as needed for the model
      var attributes = {};

      var qspData = {
        upload_phase: 'finish',
        job_id: this.get('jobId'),
        upload_reference: 1
      };

      var url = this.urlRoot() + this.toQSP(qspData);
      var options = {};

      var data = new FormData();
      data.append('file', '');

      var options = _.extend({
        type: 'POST',
        contentType: false,
        dataType: 'json',
        data: data,
        url: url
      }, this.opts);

      Backbone.Model.prototype.save.call(this, attributes, options).then(_.bind(function(response) {
        if(response.status == 200) {
          this.set('status', 200);
          this.trigger('upload-complete', this, response, options);
        } else {
          this.trigger('upload-error', this, response, options);
        }
      }, this)).fail(this.retryUploadPhase.bind(this, 'finish'));
    },
    /**
     * [retryUploadPhase description]
     * @param  {[type]} phase [description]
     * @param  {[type]} err   [description]
     * @return {[type]}       [description]
     */
    retryUploadPhase: function (phase, err) {
      console.warn('retryUploadPhase: ', phase, err);

      var failureCount = this.get('failureCount'),
          maxRetry = this.get('maxAttempts'),
          retryInterval = this.get('retryTimeout');

      if(err.status >= 400 && err.status < 500) {
        this.trigger('upload-error', this, err, this.opts);
        return;
      }

      // the user is offline, add an eventListener for when the user is back online
      // restart the transfer after that
      if(failureCount < maxRetry) {
          failureCount++;
          this.set('failureCount', failureCount);

          console.warn('retry the setup on failure: ', failureCount)

          switch (phase) {
            case 'finish':
              this.timeoutRetry = setTimeout(this.completeTailorUpload.bind(this), retryInterval * 1000);
              break;
            case 'transfer':
              this.timeoutRetry = setTimeout(this.afterSetUp.bind(this), retryInterval * 1000);
              break;
          }
          
          return;
      }

      // since any failure on backbone.save will trigger an error, lets overwrite the fail listener
      this.trigger('upload-error', this, err, this.opts);
    },
    /**
     * 
     */
    toQSP: function(obj) {
      var qspToString = '?Authorization=' + this.auth_token;

      _.forEach(obj, function(value, index) {
        var newItem = '&' + index + '=' + encodeURIComponent(value);

        qspToString += newItem;
      });

      return qspToString;
    }
});